module.exports = __webpack_public_path__ + "static/media/gray-arrow-forward.52cf4010.svg";